import * as React from 'react';
import Typography from "@mui/material/Typography";

export const HTML_TAGS = {
	p: <Typography component="p" sx={{ whiteSpace: 'pre-line', lineHeight: '2em', paddingBottom:'1em'}}/>,
	b: <b/>,
	i: <i/>
}

export function fillIn<MarkUpType>(string: string | undefined, substitutions: { [k: string]: (MarkUpType | string) }): string | MarkUpType[] {
	if (string === '' || string === undefined)
		return '';

	const keys = Object.keys(substitutions);

	const result = Array(0);

	// eslint-disable-next-line no-template-curly-in-string
	const segments : (MarkUpType| string)[]  = string.split(new RegExp('({[^}]*})'));
	for (let k = 0; k < keys.length; k++) {
		for (let s = 0; s < segments.length; s++) {
			if (segments[s] === '{' + keys[k] + '}')
				segments[s] = substitutions[keys[k]];
		}
	}
	segments_loop: for (let s = 0; s < segments.length; s++) {
		if (segments[s] === '')
			continue;
		for (let k = 0; k < keys.length; k++) {
			if (segments[s] === '{' + keys[k] + '}') {
				result.push(substitutions[keys[k]]);
				continue segments_loop;
			}
		}
		// no substitution key matched
		result.push(segments[s]);
	}

	return result;

}